import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trash2, AlertTriangle } from "lucide-react";
import { callDeletePost } from "@/services/ophim69Service";

interface ModalDeletePostProps {
  isOpen: boolean;
  onClose: () => void;
  post?: any | null;
  onCompleted?: () => void;
}

export default function ModalDeletePost({
  isOpen,
  onClose,
  post,
  onCompleted,
}: ModalDeletePostProps) {
  const [isDeleting, setIsDeleting] = React.useState(false);

  const handleDelete = async () => {
    if (!post?._id && !post?.id) return;
    setIsDeleting(true);
    try {
      const res: any = await callDeletePost(post?._id || post?.id);
      if (res) {
        onCompleted?.();
        onClose();
      }
    } finally {
      setIsDeleting(false);
    }
  };

  if (!post) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="w-5 h-5" /> Xác nhận xóa post
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg">
            <Trash2 className="w-5 h-5 text-red-600 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">
                Bạn có chắc chắn muốn xóa post này?
              </p>
              <p className="text-sm text-gray-600 mt-1">
                Hành động này không thể hoàn tác.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Thông tin post:</h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>
                <span className="font-medium">Tên:</span>{" "}
                {post?.name || "(Trống)"}
              </p>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Hủy
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isDeleting}
            className="cursor-pointer"
          >
            {isDeleting ? (
              "Đang xóa..."
            ) : (
              <>
                <Trash2 className="w-4 h-4 mr-2" />
                Xóa
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
